import React from "react";

const palette = [
  "bg-colygon",
  "bg-colygon-dark",
  "bg-colygon-light text-colygon-darkest",
  "bg-colygon",
  "bg-colygon",
];

const hash = (s) => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h << 5) - h + s.charCodeAt(i);
  return Math.abs(h);
};

const SIZES = {
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-12 w-12 text-base",
  xl: "h-20 w-20 text-xl",
  "2xl": "h-28 w-28 text-2xl",
};

export const Avatar = ({ initials, name, photoUrl, size = "md" }) => {
  const bg = palette[hash(name || initials || "x") % palette.length];
  const sz = SIZES[size] || SIZES.md;

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={name}
        data-testid="user-avatar"
        className={`${sz} rounded-full object-cover shrink-0 shadow-sm ring-2 ring-white`}
      />
    );
  }

  return (
    <div
      className={`${bg} ${sz} rounded-full flex items-center justify-center ${bg.includes("text-") ? "" : "text-white"} font-semibold tracking-wide shrink-0 shadow-sm`}
      aria-label={name}
      data-testid="user-avatar"
    >
      {initials}
    </div>
  );
};

export default Avatar;
